import { FormKeys } from '@/features/pos/components/ProductConfigurationModal/form/constants'
import {
    Form,
    FormAddonQuantities,
    FormRemovedIngredients,
} from '@/features/pos/components/ProductConfigurationModal/form/types'
import { ProductVariant } from '@/features/pos/components/ProductConfigurationModal/types'
import { toFormAddonGroup } from '@/features/pos/components/ProductConfigurationModal/utils/toFormAddonGroup'

export const getDefaultValues = (productVariant: ProductVariant, quantity = 1): Form => {
    const addonGroups = productVariant.addonGroups.reduce<NonNullable<Form[FormKeys.AddonGroups]>>(
        (addonGroups, group) => {
            const addonQuantities = group.addons.reduce<FormAddonQuantities>(
                (addonQuantities, addon) => {
                    if (!addon.quantity) return addonQuantities

                    addonQuantities[addon.id] = addon.quantity

                    return addonQuantities
                },
                {}
            )

            addonGroups[group.id] = toFormAddonGroup(group, addonQuantities)

            return addonGroups
        },
        {}
    )

    const removedIngredients = productVariant.removableIngredients.reduce<FormRemovedIngredients>(
        (removedIngredients, ingredient) => {
            if (ingredient.removed) removedIngredients[ingredient.id] = true

            return removedIngredients
        },
        {}
    )

    return {
        productVariantId: productVariant.id,
        quantity,
        addonGroups,
        removedIngredients,
    }
}
